const devConfig = {
  //////////////////////////////////////////////////////////////////////////////
  // AppSync (GraphQL)
  //////////////////////////////////////////////////////////////////////////////
  aws_appsync_graphqlEndpoint:
    "https://yjqprwankncwncol3avealtffu.appsync-api.us-east-2.amazonaws.com/graphql",

  aws_appsync_region: "us-east-2",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_apiKey: "null",

  //////////////////////////////////////////////////////////////////////////////
  // Cognito (Auth)
  //////////////////////////////////////////////////////////////////////////////
  Auth: {
    mandatorySignIn: true,
    region: "us-east-2",
    userPoolId: "us-east-2_nTmYXnf0A",
    identityPoolId: "us-east-2:023849a1-d189-4cff-a8e4-c11eeed6241c",
    userPoolWebClientId: "22gh78u6aguipfoobthvl4el72",
  },
  //////////////////////////////////////////////////////////////////////////////
  // S3
  //////////////////////////////////////////////////////////////////////////////
  Storage: {
    AWSS3: {
      bucket: "dev-prept-assets",
      region: "us-east-2",
    },
  },
};

const prodConfig = {
  //////////////////////////////////////////////////////////////////////////////
  // AppSync (GraphQL)
  //////////////////////////////////////////////////////////////////////////////
  aws_appsync_graphqlEndpoint:
    "https://gjfammoh65ebzd7jsgtfcf7yf4.appsync-api.us-east-2.amazonaws.com/graphql",
  aws_appsync_region: "us-east-2",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_apiKey: "null",

  //////////////////////////////////////////////////////////////////////////////
  // Cognito (Auth)
  //////////////////////////////////////////////////////////////////////////////
  Auth: {
    mandatorySignIn: true,
    region: "us-east-2",
    userPoolId: "us-east-2_Y4oaVrsJR",
    identityPoolId: "us-east-2:a24df854-8111-4b32-bf82-5c96bbed6586",
    userPoolWebClientId: "26j4v7q471ftd9c86mjbd0gou2",
  },
  //////////////////////////////////////////////////////////////////////////////
  // S3
  //////////////////////////////////////////////////////////////////////////////
  Storage: {
    AWSS3: {
      bucket: "prept-assets",
      region: "us-east-2",
    },
  },
};

const config = process.env.REACT_APP_STAGE === "prod" ? prodConfig : devConfig;

export default config;
